import { SSRSafeTranslationGuard } from '@zep/i18n';
import { SingularPaymentsSuccess } from '../../../../components/service/subscription/subscriptionPayment/SingularPaymentsSuccess';
export const SingularSubscriptionPaymentsSuccessPageView = () => {
  return <SSRSafeTranslationGuard data-sentry-element="SSRSafeTranslationGuard" data-sentry-component="SingularSubscriptionPaymentsSuccessPageView" data-sentry-source-file="success.tsx">
      <SingularPaymentsSuccess data-sentry-element="SingularPaymentsSuccess" data-sentry-source-file="success.tsx" />
    </SSRSafeTranslationGuard>;
};